module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAU5JREFUWEdjZBhgwDjA9jMMfgeoaRtXMPz/z0GdkPr/6c8Pprn37p39CDOPYAioaRn9p47lMFP+F9+6dr6PaAeoahntYGJgoDgE/jMyGDD8Z+BnYGBovHXtXAPRDqCW79W1jA78Z2Cwx+sAJSVjfhaOf8kMDIx81LEYEedEOUBNy7CIgYGxlzqWo8Y5kQ4wAsVNPQMjw0fG/wwXKHEIepyT5ABGBoaDN6+dc6DEAegWjjpgNARGQ4CiEFDVNGxiZGT0w5ct////v+n29fN1MDVUzYZqmoYLGBgZ4/GWC///L7x1/XwCTRygpG0sx/z/rxA+B/xlZH537+rZRzRxADklIlWjYNQB1AgBUMuKkYHBnYGRsfLW1bMdWFtEalqQ6pgWtSEuT6A0SgeNA2jRICEyBGjXJCPKAbRslBLlAHJSO6V6CPaMKLWAkP4BdwAAUMx+MAeA1nkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-nav/id_card.png
// module id = 772
// module chunks = 1